import React from "react";
import { Link, NavLink } from "react-router-dom";
import siteLogo from ".././assets/portfolio-img.png";

const baseUrl = window.location.origin;
const ResumeLink = baseUrl + "/assets/Resume.pdf";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white py-3">
      <div className="container px-5">
        <Link className="navbar-brand d-flex align-items-center gap-3" to="/">
          <img
            src={siteLogo}
            alt="Dibya Mitra"
            className="rounded-circle"
            width="44"
            height="44"
            style={{ objectFit: "cover" }}
          />
          <div>
            <div className="fw-bold logo">Dibya Mitra</div>
            <div className="prof-subtitle">Senior Backend Engineer</div>
          </div>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 small fw-bolder">
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
                to="/experiences"
              >
                Experiences
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
                to="/skills"
              >
                Skills
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
                to="/projects"
              >
                Projects
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
                to="/certifications"
              >
                Certifications
              </NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
                to="/academics"
              >
                Academics
              </NavLink>
            </li>
            <li className="nav-item">
              <a download className="nav-link" href={ResumeLink}>
                Download Resume
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
